export default "/images/framework/ClosePopup.11c1d001.svg?11c1d001";